import React from 'react';
import { motion } from 'framer-motion';
import CardSwap, { Card } from './CardSwap';
import '../Styles/Cardswipper.css';

import img1 from '../Assets/card1.avif';
import img2 from '../Assets/card2.avif';
import img3 from '../Assets/card3.avif';

// Animation variants
const fadeLeft = {
  hidden: { opacity: 0, x: -80 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.8 } },
};

const fadeRight = {
  hidden: { opacity: 0, x: 80 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.8 } },
};

const CardSwiper = () => {
  return (
    <div className="cardswipper-section" id="works">
      {/* Text Side with Fade Left */}
      <motion.div
        className="text-side"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeLeft}
      >
        <h2>Our Works</h2>

        <div className="sub-section">
          <h3>SEO Services</h3>
          <p>
            Optimize your online presence and improve your rankings with our
            data-driven SEO strategies tailored for success.
          </p>
        </div>

        <div className="sub-section">
          <h3>Social Media</h3>
          <p>
            Engage your audience and build your brand with effective social
            media marketing and targeted campaigns.
          </p>
        </div>

        <div className="sub-section">
          <h3>UI/UX Design</h3>
          <p>
            We create engaging and user-friendly interfaces that enhance user
            experience and satisfaction.
          </p>
        </div>
      </motion.div>

      {/* Cards Side with Fade Right */}
      <motion.div
        className="cards-side"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeRight}
      >
        <CardSwap
          cardDistance={60}
          verticalDistance={70}
          delay={2000}
          pauseOnHover={false}
        >
          <Card className="card">
            <img src={img1} alt="Card 1" />
          </Card>
          <Card className="card">
            <img src={img2} alt="Card 2" />
          </Card>
          <Card className="card">
            <img src={img3} alt="Card 3" />
          </Card>
        </CardSwap>
      </motion.div>
    </div>
  );
};

export default CardSwiper;
